import React, { useEffect, useState } from 'react'
import '../../ApplicationsDashboard/ApplicationsDashboard.css';
import CustomPagination from '../../../components/Pagination/CustomPagination';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../../components/Sidebar/Sidebar';
import SeedsLogo from "../../../assets/images/SeedsLogo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSearch,
    faBell,
    faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import UserProfileDropdown from '../../../components/UserProfile/UserProfile';
import './Demand.css'
import { useDispatch, useSelector } from 'react-redux';
import { getDemandReport } from '../../../redux/ReportsReducer/action';
import DatePicker from 'react-datepicker';
import DownloadReport from '../DownloadReport';
import { downloadReport, resetFilters } from '../../../utils/reportUtils';
import FunnelIconSvg from '../../../components/SVG/FunnelIconSvg';
import FilterModal from '../FilterModal/FilterModal';
import GenerateReport from '../../../components/GenerateReport/GenerateReport';
import { isAuthorised } from '../../../utils/common';
import { REPORTS_COMPONENTS } from '../../../config/reports';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import { getAuthToken } from "../../../utils/auth";

const Demand = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [showGenerateReportModal, setShowGenerateReportModal] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);

    const { demandReport, pagination, officerProfile } = useSelector((store) => {
        return {
            demandReport: store.ReportsReducer.demandReport.data,
            pagination: store.ReportsReducer.demandReport.pagination,
            officerProfile: store.UserReducer.officerProfile
        }
    }, []);

    const storedFilters = JSON.parse(sessionStorage.getItem('demandFilters')) || {};

    const [demandFilters, setDemandFilters] = useState({
        branch: storedFilters?.branch || "",
        demand_type: storedFilters?.demand_type || "",
        demand_month: storedFilters?.demand_month || "",
        from_loan_date: storedFilters?.from_loan_date || "",
        to_loan_date: storedFilters?.to_loan_date || "",
        customer_name: storedFilters?.customer_name || "",
        customer_id: storedFilters?.customer_id || "",
        loan_id: storedFilters?.loan_id || "",
        app_id: storedFilters?.app_id || "",
        tranche_id: storedFilters?.tranche_id || "",
        global_search: storedFilters?.global_search || ""
    });

    const [currentPage, setCurrentPage] = useState(parseInt(sessionStorage.getItem('reportsCurrentPage')) || 1);
    const [limit, setLimit] = useState(parseInt(sessionStorage.getItem('reportsLimit')) || 10);
    const totalCount = parseInt(sessionStorage.getItem('reportsTotalCount')) || 0;
    const totalPages = Math.ceil(totalCount / limit);

    useEffect(() => {
        dispatch(getDemandReport(currentPage, limit, demandFilters, null));

        sessionStorage.setItem('reportsCurrentPage', currentPage);
        sessionStorage.setItem('reportsLimit', limit);
        sessionStorage.setItem('demandFilters', JSON.stringify(demandFilters));
        //   }, [dispatch, limit, currentPage, demandFilters]);
    }, [dispatch, limit, currentPage]);

    useEffect(() => {
        return () => {
            sessionStorage.removeItem("demandFilters");
            sessionStorage.removeItem("reportsCurrentPage");
            sessionStorage.removeItem("reportsLimit");
            sessionStorage.removeItem("reportsTotalPages");
            sessionStorage.removeItem("reportsTotalCount");
        };
    }, []);

    const handlePageChange = (newPage) => {
        // Ensure we're working with 1-based pagination
        const pageToSet = Math.max(1, Math.min(newPage, totalPages));
        setCurrentPage(pageToSet);
        sessionStorage.setItem('reportsCurrentPage', pageToSet.toString());
    };

    const formatDate = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleFilterChange = (e) => {
        let { name, value } = e.target;

        if (typeof value === 'string') {
            value = value.replace(/[\t\n\r]+/g, '').replace(/^\s+/, '');
        }

        let updatedFilters = {
            ...demandFilters,
            [name]: value
        };

        setDemandFilters(updatedFilters);
        sessionStorage.setItem("demandFilters", JSON.stringify(updatedFilters));
    }

    const handleGenerate = (reportType, month) => {
        downloadReport(reportType, {
            demand_month: month
        },
            setIsGenerating);
    }

    useEffect(() => {
        sessionStorage.setItem('reportsCurrentPage', currentPage);
        sessionStorage.setItem('reportsLimit', limit);
    }, [limit, currentPage]);

    return (
        <>
            <div className="reportsDashboardContainer">
                <div className="reportsDashboard">
                    <Sidebar />

                    <div className="dashboardMainContent">
                        <div className="contentHeader">
                            <div className="userLogo">
                                <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
                            </div>
                            <div className="headerRightPanel">
                                {/* <div className="headerSearchBar">
                              <input type="text" placeholder="Search" />
                              <FontAwesomeIcon icon={faSearch} />
                          </div>
                          <div className="headerNotifications">
                              <FontAwesomeIcon icon={faBell} />
                              <span className="notificationBadge">9+</span>
                          </div>
                          <div className="headerHelp">
                              <FontAwesomeIcon icon={faQuestionCircle} />
                          </div> */}
                                <UserProfileDropdown />
                            </div>
                        </div>

                        <div className="pageContentWrapper">
                            <div className="pageHeaderSection">
                                <Breadcrumb items={[
                                    { label: 'Admin' },
                                    { label: 'Reports', onClick: () => navigate('/reports') },
                                    { label: 'Demand' }
                                ]} />

                                <div className="pageActions">
                                    <h2>Demand</h2>
                                </div>
                            </div>

                            <div className="searchControlSection">
                                <div className="searchGroup">
                                    {isAuthorised(
                                        officerProfile,
                                        REPORTS_COMPONENTS['demand_search']
                                    ) && <div className="tableSearchBar">
                                            <input
                                                // type="text" 
                                                type="search"
                                                placeholder="Search"
                                                name="global_search"
                                                value={demandFilters?.global_search}
                                                onChange={handleFilterChange}
                                                onInput={(e) => {
                                                    if (e.target.value === "") {
                                                        let updatedFilters = {
                                                            ...demandFilters,
                                                            global_search: e.target.value
                                                        }

                                                        setDemandFilters(updatedFilters)

                                                        dispatch(getDemandReport(1, limit, updatedFilters));
                                                        handlePageChange(1);
                                                    }
                                                }}
                                            />
                                            {/* <FontAwesomeIcon icon={faSearch} /> */}
                                        </div>}
                                    <div className="searchActionButtons">
                                        {isAuthorised(
                                            officerProfile,
                                            REPORTS_COMPONENTS['demand_search']
                                        ) && <button
                                            className="searchButton iconOnly"
                                            title="Search"
                                            onClick={() => {
                                                dispatch(getDemandReport(1, limit, demandFilters, null));
                                            }}
                                        >
                                                <FontAwesomeIcon icon={faSearch} />
                                            </button>}
                                        {isAuthorised(
                                            officerProfile,
                                            REPORTS_COMPONENTS['demand_download']
                                        ) && <button
                                            className="downloadButton"
                                            // onClick={() => setShowDownloadModal(true)}
                                            onClick={() => {
                                                downloadReport("demand", demandFilters, setIsDownloading);
                                            }}
                                            disabled={isDownloading}
                                        >
                                                {isDownloading ? (
                                                    <>
                                                        <span className="buttonSpinner"></span>
                                                        Downloading...
                                                    </>
                                                ) : (
                                                    <>
                                                        Download
                                                    </>
                                                )}
                                            </button>}
                                        {isAuthorised(
                                            officerProfile,
                                            REPORTS_COMPONENTS['demand_report_generate']
                                        ) && <button
                                            className="downloadButton"
                                            onClick={() => setShowGenerateReportModal(true)}
                                            disabled={isGenerating}
                                        >
                                                {isGenerating ? (
                                                    <>
                                                        <span className="buttonSpinner"></span>
                                                        Generating...
                                                    </>
                                                ) : (
                                                    <>
                                                        Generate Demand Report
                                                    </>
                                                )}
                                            </button>}
                                        {isAuthorised(
                                            officerProfile,
                                            REPORTS_COMPONENTS['demand_filters']
                                        ) && <button
                                            className="filterButton"
                                            onClick={() => setShowFilterModal(true)}
                                        >
                                                <FunnelIconSvg fillColor={"black"} />
                                            </button>}
                                    </div>
                                </div>
                            </div>

                            {
                                showFilterModal && (
                                    <FilterModal
                                        reportTitle={"demand"}
                                        filters={demandFilters}
                                        setFilters={setDemandFilters}
                                        resetFilters={() => {
                                            let resettedFilters = resetFilters(demandFilters);

                                            setDemandFilters(resettedFilters);
                                            dispatch(getDemandReport(1, limit, resettedFilters, null));
                                            handlePageChange(1);
                                            setShowFilterModal(false);
                                            sessionStorage.setItem("demandFilters", JSON.stringify(resettedFilters));
                                            return resettedFilters;
                                        }}
                                        handleApplyFilters={(finalFilters) => {
                                            handlePageChange(1);
                                            dispatch(getDemandReport(1, limit, finalFilters, null));
                                            setShowFilterModal(false);
                                        }}
                                        onClose={() => {
                                            setShowFilterModal(false)
                                        }}
                                    />
                                )
                            }

                            <div className="tableCard">
                                <main className="">
                                    <div className="reportsTableContainer">
                                        <table className="applications-table" style={{ overflowX: "auto" }}>
                                            <thead>
                                                <tr>
                                                    <th>Application ID</th>
                                                    {/* <th>Region</th> */}
                                                    {/* <th>Area</th> */}
                                                    <th>Branch</th>
                                                    <th>Customer Name</th>
                                                    <th>Customer ID</th>
                                                    <th>Loan ID</th>
                                                    <th>Tranche ID</th>
                                                    <th>RO - Assigned</th>
                                                    <th>Co-Borrower Name</th>
                                                    <th>Co-Borrower Mobile</th>
                                                    <th>Borrower Address</th>
                                                    <th>Loan creation Date</th>
                                                    <th>Tranche Amount</th>
                                                    <th>Tranche Count</th>
                                                    <th>Customer Mobile No.</th>
                                                    <th>OD Status</th>
                                                    <th>DPD</th>
                                                    <th>Tranche O/S Total</th>
                                                    <th>Limit Available</th>
                                                    <th>Last Due Amt Total/Tranche</th>
                                                    <th>Last Paid Amt Total/Tranche</th>
                                                    <th>Last Due Date</th>
                                                    <th>Last Payment Date</th>
                                                    <th>Current Due Amt Total/Tranche</th>
                                                    <th>Current OD Amt Total/Tranche</th>
                                                    <th>Current Demand Amt Total/Tranche</th>
                                                </tr>

                                                {/* <tr className="filter-row">
                                      <td>
                                          <input
                                              type="text"
                                              name="app_id"
                                              value={demandFilters?.app_id || ""}
                                              placeholder="Search"
                                              className="column-filter"
                                              onChange={handleFilterChange}
                                          />
                                      </td>
                                      <td>
                                          <input
                                              type="text"
                                              name="branch"
                                              value={demandFilters?.branch || ""}
                                              placeholder="Search"
                                              className="column-filter"
                                              onChange={handleFilterChange}
                                          />
                                      </td>
                                      <td>
                                          <input
                                              type="text"
                                              name="customer_name"
                                              value={demandFilters?.customer_name || ""}
                                              placeholder="Search"
                                              className="column-filter"
                                              onChange={handleFilterChange}
                                          />
                                      </td>
                                      <td>
                                          <input
                                              type="text"
                                              name="customer_id"
                                              value={demandFilters?.customer_id || ""}
                                              placeholder="Search"
                                              className="column-filter"
                                              onChange={handleFilterChange}
                                          />
                                      </td>
                                      <td>
                                          <input
                                              type="text"
                                              name="loan_id"
                                              value={demandFilters?.loan_id || ""}
                                              placeholder="Search"
                                              className="column-filter"
                                              onChange={handleFilterChange}
                                          />
                                      </td>
                                      <td>
                                          <input
                                              type="text"
                                              name="tranche_id"
                                              value={demandFilters?.tranche_id || ""}
                                              placeholder="Search"
                                              className="column-filter"
                                              onChange={handleFilterChange}
                                          />
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td>
                                          <select
                                              name="demand_type"
                                              value={demandFilters?.demand_type || ""}
                                              className="column-filter"
                                              onChange={handleFilterChange}
                                          >
                                              <option value="">All</option>
                                              <option value="Current">Current</option>
                                              <option value="Overdue">Overdue</option>
                                              <option value="All">All Types</option>
                                          </select>
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                  </tr> */}
                                            </thead>
                                            <tbody>
                                                {
                                                    demandReport?.length === 0 ?
                                                        <tr>
                                                            <td colSpan={10} className="no-data-cell">
                                                                No records found
                                                            </td>
                                                        </tr> :
                                                        demandReport?.map((demand, index) => (
                                                            <tr key={index}>
                                                                <td>{demand?.app_id}</td>
                                                                {/* <td>{""}</td> */}
                                                                {/* <td>{""}</td> */}
                                                                <td>{demand?.branch}</td>
                                                                <td>{demand?.customer_name}</td>
                                                                <td>{demand?.customer_id}</td>
                                                                <td>{demand?.loan_id}</td>
                                                                <td>{demand?.tranche_id}</td>
                                                                <td>{demand?.ro_assigned}</td>
                                                                <td>{demand?.co_borrower_name}</td>
                                                                <td>{demand?.co_borrower_mobile}</td>
                                                                <td>{demand?.borrower_address}</td>
                                                                <td>{demand?.loan_creation_date}</td>
                                                                <td>{demand?.tranche_amount}</td>
                                                                <td>{demand?.tranche_count}</td>
                                                                <td>{demand?.cust_mobile_no}</td>
                                                                <td>{demand?.od_status}</td>
                                                                <td>{demand?.dpd}</td>
                                                                <td>{demand?.tranche_os_total}</td>
                                                                <td>{demand?.limit_available}</td>
                                                                <td>{demand?.last_due_amt_total_tranche}</td>
                                                                <td>{demand?.last_paid_amt_total_tranche}</td>
                                                                <td>{demand?.last_due_date}</td>
                                                                <td>{demand?.last_payment_date}</td>
                                                                <td>{demand?.current_due_amount_total_tranche}</td>
                                                                <td>{demand?.current_od_amount_total_tranche}</td>
                                                                <td>{demand?.current_demand_amount_total_tranche}</td>
                                                            </tr>
                                                        ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    {demandReport?.length > 0 && <div className="paginationControls">
                                        <CustomPagination
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>}
                                </main>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {
                showDownloadModal && (
                    <DownloadReport
                        isOpen={showDownloadModal}
                        onClose={() => setShowDownloadModal(false)}
                        reportTitle={"demand"}
                    />
                )
            }

            {
                showGenerateReportModal && (
                    <GenerateReport
                        isOpen={showGenerateReportModal}
                        onClose={() => setShowGenerateReportModal(false)}
                        reportTitle={"Generate Demand Report"}
                        minLimit={24}
                        maxLimit={1}
                        handleGenerate={handleGenerate}
                    />
                )
            }
        </>
    )
}

export default Demand